(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranges-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.rgInit) return;
    root.dataset.rgInit = '1';
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    var nav = root.querySelector('[data-nav]');
    var navToggle = root.querySelector('[data-nav-toggle]');
    var navCur = root.querySelector('[data-nav-cur]');
    function isMobile() { return window.matchMedia('(max-width: 980px)').matches; }
    function updateNav() {
      var on = root.querySelector('.rg-tab.is-on');
      if (navCur && on) navCur.textContent = on.textContent.trim();
    }
    function setNav(open) {
      if (!nav) return;
      nav.classList.toggle('is-closed', !open);
      if (navToggle) navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (navToggle) navToggle.addEventListener('click', function () { setNav(nav.classList.contains('is-closed')); });
    updateNav();

    function clamp(scope) {
      scope.querySelectorAll('[data-desc]').forEach(function (p) {
        if (p.nextElementSibling && p.nextElementSibling.classList.contains('rg-rm')) return;
        if (p.scrollHeight > p.clientHeight + 2) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'rg-rm'; b.textContent = 'Read more';
          b.addEventListener('click', function () {
            var open = p.classList.toggle('is-open');
            b.textContent = open ? 'Read less' : 'Read more';
          });
          p.after(b);
        }
      });
    }
    function activate(h) {
      var hit = null;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === h;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === h;
        p.hidden = !on;
        if (on) hit = p;
      });
      if (hit) clamp(hit);
      updateNav();
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-tab'));
        if (isMobile() && nav) {
          setNav(false);
          nav.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    var sl = root.querySelector('[data-slider]');
    if (sl) {
      var track = sl.querySelector('.rg-slides');
      var slides = sl.querySelectorAll('.rg-slide');
      var dots = sl.querySelectorAll('[data-dot]');
      var n = slides.length, cur = 0, timer = null;
      var auto = parseFloat(sl.getAttribute('data-auto')) || 0;
      function go(k) {
        cur = (k + n) % n;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function (d, x) { d.classList.toggle('is-on', x === cur); });
        slides.forEach(function (s, x) { s.inert = x !== cur; });
      }
      function stop() { clearInterval(timer); }
      function play() { stop(); if (auto > 0 && n > 1) timer = setInterval(function () { go(cur + 1); }, auto * 1000); }
      var pv = sl.querySelector('[data-prev]'), nx = sl.querySelector('[data-next]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1); play(); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); play(); });
      dots.forEach(function (d, x) { d.addEventListener('click', function () { go(x); play(); }); });
      sl.addEventListener('mouseenter', stop);
      sl.addEventListener('mouseleave', play);
      var sx = 0;
      sl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
      sl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? cur + 1 : cur - 1);
        play();
      }, { passive: true });
      root.addEventListener('shopify:block:select', function (e) {
        slides.forEach(function (s, x) { if (s.getAttribute('data-bid') === e.detail.blockId) { go(x); stop(); } });
      });
      go(0); play();
    }
    /* ---- image popup (lightbox) with zoom ---- */
    var lb = root.querySelector('.rg-lbx');
    var lbImg = lb ? lb.querySelector('.rg-lbx__img') : null;
    var lbCap = lb ? lb.querySelector('.rg-lbx__cap') : null;
    var lbCnt = lb ? lb.querySelector('.rg-lbx__count') : null;
    var lbPrev = lb ? lb.querySelector('[data-lbx-prev]') : null;
    var lbNext = lb ? lb.querySelector('[data-lbx-next]') : null;
    var gal = [], gi = 0, gTitle = '', sc2 = 1, tx = 0, ty = 0, dragging = false, d0x = 0, d0y = 0, t0x = 0, t0y = 0, lastFocus = null, swX = 0, swY = 0;

    function lbApply() {
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc2 + ')';
      lbImg.classList.toggle('is-zoomed', sc2 > 1);
      if (sc2 <= 1) { tx = 0; ty = 0; }
    }
    function lbReset() { sc2 = 1; tx = 0; ty = 0; lbImg.style.transform = ''; lbImg.classList.remove('is-zoomed'); }
    function lbRender() {
      var it = gal[gi]; if (!it) return;
      lbReset();
      lbImg.src = it.s;
      lbImg.alt = gTitle + (it.c ? ' - ' + it.c : '');
      lbCap.textContent = gTitle + (it.c ? ' - ' + it.c : '');
      lbCnt.textContent = (gi + 1) + ' / ' + gal.length;
      lbPrev.hidden = lbNext.hidden = gal.length < 2;
    }
    function openLb(range, i) {
      if (!lb || !range) return;
      try { gal = JSON.parse(range.getAttribute('data-gallery') || '[]'); } catch (err) { gal = []; }
      if (!gal.length) return;
      gTitle = range.getAttribute('data-title') || '';
      gi = Math.min(Math.max(i, 0), gal.length - 1);
      lbRender();
      lastFocus = document.activeElement;
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('.rg-lbx__close').focus();
    }
    function closeLb() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      lbReset();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function lbStep(d) { gi = (gi + d + gal.length) % gal.length; lbRender(); }

    if (lb) {
      lb.querySelectorAll('[data-lbx-close]').forEach(function (b) { b.addEventListener('click', closeLb); });
      lbPrev.addEventListener('click', function () { lbStep(-1); });
      lbNext.addEventListener('click', function () { lbStep(1); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowRight' && gal.length > 1) lbStep(1);
        if (e.key === 'ArrowLeft' && gal.length > 1) lbStep(-1);
      });
      lbImg.addEventListener('dblclick', function () {
        if (sc2 === 1) { sc2 = 2.4; } else { sc2 = 1; tx = 0; ty = 0; }
        lbApply();
      });
      lbImg.addEventListener('wheel', function (e) {
        e.preventDefault();
        sc2 = Math.min(Math.max(sc2 + (e.deltaY > 0 ? -0.2 : 0.2), 1), 4);
        lbApply();
      }, { passive: false });
      lbImg.addEventListener('pointerdown', function (e) {
        if (sc2 <= 1) return;
        dragging = true; lbImg.classList.add('is-drag');
        d0x = e.clientX; d0y = e.clientY; t0x = tx; t0y = ty;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        tx = t0x + (e.clientX - d0x); ty = t0y + (e.clientY - d0y);
        lbApply();
      });
      window.addEventListener('pointerup', function () { dragging = false; lbImg.classList.remove('is-drag'); });
      var stage = lb.querySelector('.rg-lbx__stage');
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) { swX = e.touches[0].clientX; swY = e.touches[0].clientY; }
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sc2 > 1 || gal.length < 2) return;
        var dx = swX - e.changedTouches[0].clientX, dy = swY - e.changedTouches[0].clientY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) lbStep(dx > 0 ? 1 : -1);
      }, { passive: true });
    }
    root.addEventListener('keydown', function (e) {
      var t = e.target.closest ? e.target.closest('[data-lb]') : null;
      if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openLb(t.closest('.rg-range'), parseInt(t.getAttribute('data-i'), 10) || 0); }
    });

    var first = root.querySelector('.rg-panel:not([hidden])');
    if (first) clamp(first);

    root.addEventListener('click', function (e) {
      var lbt = e.target.closest('[data-lb]');
      if (lbt) { openLb(lbt.closest('.rg-range'), parseInt(lbt.getAttribute('data-i'), 10) || 0); return; }
      var sc = e.target.closest('[data-scroll-tabs]');
      if (sc) {
        e.preventDefault();
        if (nav) {
          setNav(true);
          nav.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      var dt = e.target.closest('[data-target]');
      if (dt) {
        e.preventDefault();
        var tid = dt.getAttribute('data-target');
        var tg = (tid && tid !== 'range-') ? document.getElementById(tid) : null;
        if (tg) {
          var pn = tg.closest('[data-panel]');
          if (pn) activate(pn.getAttribute('data-panel'));
          tg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (dt.classList.contains('rg-chip')) {
          dt.parentNode.querySelectorAll('.rg-chip').forEach(function (c) { c.classList.toggle('is-on', c === dt); });
        }
        return;
      }
      var eye = e.target.closest('[data-eye]');
      if (eye) {
        var r = eye.closest('.rg-range');
        var on = r.classList.toggle('is-shown');
        eye.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = on ? eye.getAttribute('data-hide') : eye.getAttribute('data-show');
        eye.setAttribute('aria-label', lbl);
        eye.setAttribute('title', lbl);
        return;
      }
      var a = e.target.closest('a[href^="#"]');
      if (a && a.getAttribute('href').length > 1) {
        var target = null;
        try { target = root.querySelector(a.getAttribute('href')); } catch (err) {}
        if (target) {
          e.preventDefault();
          var panel = target.closest('[data-panel]');
          if (panel) activate(panel.getAttribute('data-panel'));
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });

    var qs = new URLSearchParams(window.location.search);
    var cat = qs.get('category');
    if (cat) {
      var h = cat.toLowerCase();
      if (root.querySelector('[data-tab="' + h.replace(/"/g, '') + '"]')) activate(h);
    }
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        var p = root.querySelector('.rg-panel:not([hidden])');
        if (p) clamp(p);
      }, 200);
    });
  }
  function boot() { document.querySelectorAll('.rg').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
